import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import React, { Component, PureComponent } from 'react';
import { Consumer } from './portal-provider';

var portalTarget = function portalTarget(name) {
  return function (PortalTargetComponent) {
    var PortalTargetCore =
    /*#__PURE__*/
    function (_Component) {
      _inherits(PortalTargetCore, _Component);

      function PortalTargetCore(props) {
        var _this;

        _classCallCheck(this, PortalTargetCore);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(PortalTargetCore).call(this, props));
        _this.state = {
          children: []
        };
        props.portalConnector.registerTarget(name, _assertThisInitialized(_this));
        return _this;
      }

      _createClass(PortalTargetCore, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.portalConnector.removeTarget(name, this);
        }
      }, {
        key: "updateChildren",
        value: function updateChildren(children) {
          this.setState({
            children: children
          });
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(PortalTargetComponent, null, this.state.children);
        }
      }]);

      return PortalTargetCore;
    }(Component);

    var PortalTarget =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(PortalTarget, _PureComponent);

      function PortalTarget() {
        _classCallCheck(this, PortalTarget);

        return _possibleConstructorReturn(this, _getPrototypeOf(PortalTarget).apply(this, arguments));
      }

      _createClass(PortalTarget, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          return React.createElement(Consumer, null, function (portalConnector) {
            return React.createElement(PortalTargetCore, _extends({}, _this2.props, {
              portalConnector: portalConnector
            }));
          });
        }
      }]);

      return PortalTarget;
    }(PureComponent);

    PortalTarget.displayName = 'portalTarget';
    return PortalTarget;
  };
};

export default portalTarget;